module.exports = __webpack_public_path__ + "static/media/user-dm.307c6d31.png";